import DataTable from "@standard/components/DataTable";

const columns = [
  {
    label: "Name",
    name: "name",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Alias",
    name: "alias",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Province",
    name: "province",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
];

const config = {
  enableInsert: false,
  enableActive: false,
  enableEdit: true,
  enableTrash: false,
  enableView: true,
  onBeforeBind: (data) => {
    return data.map((item) => {
      const {} = item.values;

      return item;
    });
  },
};

export default ({ url }) => {
  return <DataTable columns={columns} url={url} {...config} />;
};
